import { useMemo } from 'react';

import { ProductDetailsReviews, ProductDetailsReviewsSkeleton } from '@components/product/ProductDetailsReviews';

import { useProductDetailsReviewsQuery } from './gql/graphql.v3.generated';

const VISIBLE_REVIEWS_COUNT = 3;

interface Props {
  className?: string,
  productId: number,
}

export const ProductDetailsReviewsContainer: React.FC<Props> = ({
  className,
  productId,
}) => {
  const { data, loading } = useProductDetailsReviewsQuery({
    variables: {
      first: VISIBLE_REVIEWS_COUNT,
      productId,
    },
    context: {
      batch: true,
    },
  });

  const reviews = useMemo(
    () => (
      data?.productReviews?.edges.map(
        (edge) => edge!.node!,
      ) || []
    ),
    [data],
  );

  if (loading) {
    return (
      <ProductDetailsReviewsSkeleton
        className={className}
        count={VISIBLE_REVIEWS_COUNT}
      />
    );
  }

  if (reviews.length) {
    return (
      <ProductDetailsReviews
        className={className}
        reviews={reviews}
        isHasMore={!!data?.productReviews?.pageInfo.hasNextPage}
      />
    );
  }

  return null;
};
